import React, { Component } from "react";
import axios, { CancelToken } from "axios";
import { Translate, I18n } from "react-redux-i18n";
import { setAlert } from "../../../actions/alertActions";
import { connect } from "react-redux";
import Card from "react-bootstrap/Card";
import Accordion from "react-bootstrap/Accordion";
import RequestNetworkAccess from "../../evs/modals/RequestNetworkAccess";
import RequestPhysicalCard from "../../evs/modals/RequestPhysicalCard";
import ActivateCard from "../../evs/modals/ActivateCard";
import {
  handleCardStatus,
  TOKEN_STATUS,
  NETWORK_TYPE,
} from "../../utils/Utils";
import LoadingSpinner from "../../utils/components/LoadingSpinner";

import "../../../styles/components/account/manageAccount/Contracts.scss";
import "../../../styles/utils/_loadingScreen.scss";
import evioSmallCard from "../../../styles/images/evio_mini_card.svg";

import back from "../../../styles/images/arrow_black.svg";
import arrow from "../../../styles/images/arrow_black.svg";
import networkOn from "../../../styles/images/network_on.svg";
import networkOff from "../../../styles/images/network_off.svg";
// import { relativeTimeRounding } from "moment";

class Contracts extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      masterContract: {},
      userContractsReturned: false,
      userContracts: {},
      showCreateContract: false,
      showDeleteContract: false,
      showEditContract: false,
      showTariff: false,
      deleteId: null,
      contractData: null,
      collapsed: [],
      selectedContract: null,
      associatedEdit: false,
      isCompany: true,
      isLoadingGireve: false,
      isLoadingMobie: false,
      isLoading: false,
      isLoadingNetworkMobie: false,
      isLoadingNetworkGireve: false,

      modals: {
        requestNetworkAccess: false,
        requestPhysicalCard: false,
        activateCard: false,
        associatePhysicalCard: false,
      },
    };

    this.handleOnClickAccordion = this.handleOnClickAccordion.bind(this);
    this.joinNetwork = this.joinNetwork.bind(this);
    this.activateNetwork = this.activateNetwork.bind(this);
    this.deactivateNetwork = this.deactivateNetwork.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchContracts();
  }

  componentWillUnmount() {
    if (this.cancel !== null) this.cancel("Component is unmounting");
    this._mounted = false;
  }

  fetchContracts() {
    axios
      .get("/api/private/contracts", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((response) => {
        if (response.status === 200) {
          this.safeSetState(
            {
              isLoadingNetworkMobie: false,
              isLoadingNetworkGireve: false,
              isLoadingMobie: false,
              isLoadingGireve: false,
              isLoading: false,
              userContracts: response.data.reverse(),
              masterContract: response.data.find((elt) => {
                return elt.contractType === "user";
              }),
            },
            () => {
              this.safeSetState(this.renderContracts);
            }
          );

          this.safeSetState({ userContractsReturned: true });

          let collapsed = [];
          for (let i = 0; i < response.data.length; i++) {
            collapsed.push(false);
          }
          this.safeSetState({ collapsed: collapsed });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  updateUserAndMasterContracts(network, status, contractId) {
    const newUserContracts = this.state.userContracts.map((userContract) => {
      if (userContract._id === contractId) {
        return {
          ...userContract,
          networks: userContract?.networks.map((net) => {
            if (net.network !== network) {
              return net;
            }
            return {
              ...net,
              tokens: net.tokens.map((token) => ({ ...token, status })),
            };
          }),
        };
      }
      return userContract;
    });

    this.safeSetState(
      {
        userContracts: newUserContracts,
        masterContract: newUserContracts.find((elt) => {
          return elt.contractType === "user";
        }),
      },
      () => {
        this.safeSetState(this.renderContracts);
      }
    );
  }

  joinNetwork(network, contractId) {
    const post = {
      network: network,
      contractId: contractId,
    };

    if (network === "MobiE") {
      this.safeSetState({
        isLoadingNetworkMobie: true,
      });
    } else if (network === "Gireve") {
      this.safeSetState({
        isLoadingNetworkGireve: true,
      });
    }

    axios
      .post("/api/private/contracts/activeNetworks", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t(res.data?.message?.message), "primary");
          this.fetchContracts();
          if (network === "MobiE") {
            this.safeSetState({
              isLoadingNetworkMobie: false,
            });
          } else if (network === "Gireve") {
            this.safeSetState({
              isLoadingNetworkGireve: false,
            });
          }
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  activateNetwork(network, contractId) {
    const patch = {
      network: network,
      contractId: contractId,
    };

    if (network === "MobiE") {
      this.safeSetState({
        isLoadingMobie: true,
      });
    } else if (network === "Gireve") {
      this.safeSetState({
        isLoadingGireve: true,
      });
    } else {
      this.safeSetState({
        isLoading: true,
      });
    }
    this.updateUserAndMasterContracts(network, "activating", contractId);
    axios
      .patch("/api/private/contracts/activeNetwork", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((response) => {
        if (response.status === 200) {
          if (network === "MobiE") {
            this.safeSetState({
              isLoadingMobie: false,
            });
          } else if (network === "Gireve") {
            this.safeSetState({
              isLoadingGireve: false,
            });
          } else {
            this.safeSetState({
              isLoading: false,
            });
          }
          this.props.setAlert(I18n.t("network_ActivationSuccess"), "primary");
          this.updateUserAndMasterContracts(network, "active", contractId);
        }
      })
      .catch((err) => {
        this.fetchContracts();
        this.updateUserAndMasterContracts(network, "inactive", contractId);
        this.props.setAlert(I18n.t(err.response.data.message), "danger");
      });
  }

  deactivateNetwork(network, contractId) {
    const patch = {
      network: network,
      contractId: contractId,
    };

    if (network === "MobiE") {
      this.safeSetState({
        isLoadingMobie: true,
      });
    } else if (network === "Gireve") {
      this.safeSetState({
        isLoadingGireve: true,
      });
    } else {
      this.safeSetState({
        isLoading: true,
      });
    }
    this.updateUserAndMasterContracts(network, "inactivating", contractId);
    axios
      .patch("/api/private/contracts/inactiveNetwork", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((response) => {
        if (response.status === 200) {
          if (network === "Gireve") {
            this.safeSetState({
              isLoadingGireve: false,
            });
          } else if (network === "MobiE") {
            this.safeSetState({
              isLoadingMobie: false,
            });
          } else {
            this.safeSetState({
              isLoading: false,
            });
          }
          this.props.setAlert(I18n.t("network_DeactivationSuccess"), "primary");
          this.updateUserAndMasterContracts(network, "inactive", contractId);
        }
      })
      .catch((err) => {
        this.fetchContracts();
        this.updateUserAndMasterContracts(network, "active", contractId);
        this.props.setAlert(I18n.t(err.response.data.message), "danger");
      });
  }

  handleOnClickAccordion(key) {
    let newCollapsable = this.state.collapsed;

    newCollapsable[key] = !this.state.collapsed[key];

    this.safeSetState({ collapsed: newCollapsable });
  }

  handleContractDelete(e, id) {
    e.stopPropagation();
    //Stores the the correspondent clicked contact ID and opens the delete confirmation modal
    this.safeSetState({
      deleteId: id,
      showDeleteContract: true,
    });
  }

  handleContractEdit(e, contract) {
    e.stopPropagation();
    this.safeSetState({
      contractData: contract,
      showEditContract: true,
    });
  }

  handleShowTariff(e, contract) {
    e.stopPropagation();
    this.safeSetState({
      contractData: contract,
      showTariff: true,
    });
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  renderNetworkControlButtons(contract, status, network, item) {
    //NETWORK MOBIE
    if (network === NETWORK_TYPE.MOBIE) {
        if (
          contract.contractType !== "user" &&
          status.mobieStatus === TOKEN_STATUS.ACTIVE
        ) {
          return (
            <div className="net-field">
              {this.state.isLoadingMobie ? (
                <LoadingSpinner />
              ) : (
                <button
                  type="button"
                  className="join-bt"
                  onClick={() => {
                    this.deactivateNetwork("MobiE", contract._id);
                  }}
                >
                  <Translate value="backOffice_contracts_network_deactivation_button" />
                </button>
              )}
            </div>
          );
        } else if (status.mobieStatus === TOKEN_STATUS.INACTIVE) {
          return (
            <div className="net-field">
              {this.state.isLoadingMobie ? (
                <LoadingSpinner />
              ) : (
                <button
                  type="button"
                  className="join-bt"
                  onClick={() => {
                    this.activateNetwork("MobiE", contract._id);
                  }}
                >
                  <Translate value="backOffice_contracts_network_activation_button" />
                </button>
              )}
            </div>
          );
        } else if (status.mobieStatus === TOKEN_STATUS.INACTIVATING) {
          return (
            <div className="net-field">
              <button
                type="button"
                className="join-bt-loading"
                onClick={() => {}}
                disabled={true}
              >
                <Translate value="deactivating" />
              </button>
            </div>
          );
        } else if (status.mobieStatus === TOKEN_STATUS.ACTIVATING) {
          return (
            <div className="net-field">
              <button
                type="button"
                className="join-bt-loading"
                onClick={() => {}}
                disabled={true}
              >
                <Translate value="activating" />
              </button>
            </div>
          );
        }
    }

    //NETWORK INTERNATIONAL
    else if (network === NETWORK_TYPE.INTERNATIONAL_1) {
      if (
        contract.contractType !== "user" &&
        status.internationalStatus === TOKEN_STATUS.ACTIVE
      ) {
        return (
          <div className="net-field">
            {this.state.isLoadingGireve ? (
              <LoadingSpinner />
            ) : (
              <button
                type="button"
                className="join-bt"
                onClick={() => {
                  this.deactivateNetwork("Gireve", contract._id);
                }}
              >
                <Translate value="backOffice_contracts_network_deactivation_button" />
              </button>
            )}
          </div>
        );
      } else if (status.internationalStatus === TOKEN_STATUS.INACTIVE) {
        return (
          <div className="net-field">
            {this.state.isLoadingGireve ? (
              <LoadingSpinner />
            ) : (
              <button
                type="button"
                className="join-bt"
                onClick={() => {
                  this.activateNetwork("Gireve", contract._id);
                }}
              >
                <Translate value="backOffice_contracts_network_activation_button" />
              </button>
            )}
          </div>
        );
      } else if (status.internationalStatus === TOKEN_STATUS.INACTIVATING) {
        return (
          <div className="net-field">
            <button
              type="button"
              className="join-bt-loading"
              onClick={() => {}}
              disabled={true}
            >
              <Translate value="deactivating" />
            </button>
          </div>
        );
      } else if (status.internationalStatus === TOKEN_STATUS.ACTIVATING) {
        return (
          <div className="net-field">
            <button
              type="button"
              className="join-bt-loading"
              onClick={() => {}}
              disabled={true}
            >
              <Translate value="activating" />
            </button>
          </div>
        );
      }
    } else {
      // OTHER NETWORK
      const status_other_networks = item.tokens.find(
        (element) => element.tokenType === "APP_USER"
      );
      if (
        contract.contractType !== "user" &&
        status_other_networks.status === "active"
      ) {
        return (
          <div className="net-field">
            {this.state.isLoading ? (
              <LoadingSpinner />
            ) : (
              <button
                type="button"
                className="join-bt"
                onClick={() => {
                  this.deactivateNetwork(network, contract._id);
                }}
              >
                <Translate value="backOffice_contracts_network_deactivation_button" />
              </button>
            )}
          </div>
        );
      } else if (status_other_networks.status === TOKEN_STATUS.INACTIVE) {
        return (
          <div className="net-field">
            {this.state.isLoading ? (
              <LoadingSpinner />
            ) : (
              <button
                type="button"
                className="join-bt"
                name={network}
                onClick={() => {
                  this.activateNetwork(network, contract._id);
                }}
              >
                <Translate value="backOffice_contracts_network_activation_button" />
              </button>
            )}
          </div>
        );
      } else if (status_other_networks.status === TOKEN_STATUS.INACTIVATING) {
        return (
          <div className="net-field">
            <button
              type="button"
              className="join-bt-loading"
              onClick={() => {}}
              disabled={true}
            >
              <Translate value="deactivating" />
            </button>
          </div>
        );
      } else if (status_other_networks.status === TOKEN_STATUS.ACTIVATING) {
        return (
          <div className="net-field">
            <button
              type="button"
              className="join-bt-loading"
              onClick={() => {}}
              disabled={true}
            >
              <Translate value="activating" />
            </button>
          </div>
        );
      }
    }
  }

  renderNetworks(contract, masterContract) {
    const status = handleCardStatus(contract);

    return (
      <div className="network-container">
        {contract.networks
          .filter(
            (obj) =>
              obj.name !== "MobiE" &&
              obj.name !== "server_international_network_1" &&
              obj.isVisible
          )
          .map((item) => (
            <div className="net-item" key={item.networkName}>
              <div className="width200">
                <div className="net-field">
                  {item.tokens.find(
                    (element) => element.tokenType === "APP_USER"
                  ).status === "active" ? (
                    <img src={networkOn} alt="Network On" />
                  ) : (
                    <img src={networkOff} alt="Network Off" />
                  )}
                  {item.name}
                </div>
              </div>
              <div className="net-field">
                {item.tokens.find((element) => element.tokenType === "APP_USER")
                  .status === "active" ? (
                  <Translate value="backOffice_network_other_networks_access_granted_subtitle" />
                ) : (
                  <Translate value="backOffice_network_other_networks_no_access_granted_subtitle" />
                )}
              </div>
              {this.renderNetworkControlButtons(
                contract,
                status,
                item.name,
                item
              )}
            </div>
          ))}

        <div className="net-item">
          <div className="width200">
            <div className="net-field">
              {status.mobieStatus === TOKEN_STATUS.ACTIVE ? (
                <img src={networkOn} alt="Network On" />
              ) : (
                <img src={networkOff} alt="Network Off" />
              )}
              <Translate value="backOffice_network_typeMobie" />
            </div>
          </div>
          <div className="net-field">
            {status.mobieStatus === TOKEN_STATUS.ACTIVE ? (
              <Translate value="backOffice_network_mobie_access_granted_subtitle" />
            ) : (
              <Translate value="backOffice_network_mobie_no_access_granted_subtitle" />
            )}
          </div>
          {this.renderNetworkControlButtons(contract, status, "MobiE")}
        </div>

        <div className={"net-item"}>
          <div className="width200">
            <div className="net-field">
              {status.internationalStatus === TOKEN_STATUS.ACTIVE ? (
                <img src={networkOn} alt="Network On" />
              ) : (
                <img src={networkOff} alt="Network Off" />
              )}
              <Translate value="backOffice_network_typeInternational" />
            </div>
          </div>
          <div className="net-field">
            {status.internationalStatus === TOKEN_STATUS.ACTIVE ? (
              <Translate value="backOffice_network_international_access_granted_subtitle" />
            ) : (
              <Translate value="backOffice_network_international_no_access_granted_subtitle" />
            )}
          </div>
          {this.renderNetworkControlButtons(
            contract,
            status,
            "server_international_network_1"
          )}
        </div>

        {!this.props.isCompany && status.mobieStatus === TOKEN_STATUS.ACTIVE ? (
          status.physicalCardStatus ===
          TOKEN_STATUS.ACTIVE ? null : status.physicalCardStatus ===
            TOKEN_STATUS.TO_REQUEST ? (
            <>
              <div className="net-item physical-card-container">
                <Translate value="backOffice_network_physicalCard_toRequest" />
                <button
                  type="button"
                  className="physic-card-bt"
                  onClick={() => {
                    this.safeSetState({ selectedContract: contract }, () =>
                      this.setModal("activateCard", true)
                    );
                  }}
                >
                  <Translate value="backOffice_network_activate_bt" />
                </button>
              </div>
            </>
          ) : (
            <>
              {this.props.brand.brandName === "EVIO" && (
                <div className="net-item physical-card-container">
                  <Translate value="backOffice_network_physicalCard_request_subTitle" />
                  <button
                    type="button"
                    className="physic-card-bt"
                    onClick={() => {
                      this.safeSetState({ selectedContract: contract }, () =>
                        this.setModal("requestPhysicalCard", true)
                      );
                    }}
                  >
                    <Translate value="backOffice_network_request_physicalCard_bt" />
                  </button>
                </div>
              )}
            </>
          )
        ) : null}

        {this.props.isCompany ? (
          status.physicalCardStatus === TOKEN_STATUS.ACTIVE ? (
            <>
              <div className="net-item physical-card-container">
                <div className="physic-card-container">
                  {(this.props.wasAdmin ||
                    this.props.userPackage?.cardAssociationEnabled) && (
                    <button
                      type="button"
                      className="associate-physic-card-bt"
                      onClick={() => {
                        this.safeSetState({
                          selectedContract: contract,
                          associatedEdit: true,
                        });
                        this.setModal("associatePhysicalCard", true);
                      }}
                    >
                      <Translate value="backOffice_network_edit_associated_physicalCard_bt" />
                    </button>
                  )}
                </div>
              </div>
            </>
          ) : status.physicalCardStatus === TOKEN_STATUS.TO_REQUEST ? (
            <>
              {
                <div className="net-item physical-card-container">
                  <Translate value="backOffice_contract_physicalCard_Request" />
                  <button
                    type="button"
                    className="physic-card-bt"
                    onClick={() => {
                      this.safeSetState({ selectedContract: contract });
                      this.setModal("activateCard", true);
                    }}
                    disabled={
                      !(contract.cardPhysicalStateInfo === "ASSOCIATED")
                    }
                    style={{ borderColor: "black", border: "1px solid #000" }}
                  >
                    <Translate value="backOffice_network_activate_bt" />
                  </button>
                </div>
              }
            </>
          ) : (
            <>
              <div className="net-item physical-card-container">
                <Translate value="backOffice_network_physicalCard_request_associate_subTitle" />
                <div className="physic-card-container">
                  {this.props.brand.brandName === "EVIO" && (
                    <button
                      type="button"
                      className="physic-card-bt"
                      onClick={() => {
                        this.safeSetState({ selectedContract: contract });
                        this.setModal("requestPhysicalCard", true);
                      }}
                    >
                      <Translate value="backOffice_network_request_physicalCard_bt" />
                    </button>
                  )}
                  {(this.props.wasAdmin ||
                    this.props.userPackage?.cardAssociationEnabled) && (
                    <button
                      type="button"
                      className="associate-physic-card-bt"
                      onClick={() => {
                        this.safeSetState({ selectedContract: contract });
                        this.setModal("associatePhysicalCard", true);
                      }}
                    >
                      <Translate value="backOffice_network_associate_physicalCard_bt" />
                    </button>
                  )}
                </div>
              </div>
            </>
          )
        ) : null}
      </div>
    );
  }

  deleteContract() {
    axios
      .delete("/api/private/contracts", {
        data: {
          _id: this.state.deleteId,
        },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((response) => {
        //Close Contract Delete Modal
        if (response.status === 200) {
          this.safeSetState({ showDeleteContract: false });
          //Update Contract Listing
          this.fetchContracts();
          this.props.setAlert(
            I18n.t("backOffice_contracts_cardDeleteSuccessAlert"),
            "primary"
          );
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  renderContracts() {
    return this.state.userContracts.map((contract, index) => {
      return (
        <Accordion id="connectorType" key={index}>
          <Card>
            <Accordion.Toggle
              as={Card.Header}
              eventKey="0"
              key={index}
              onClick={this.handleOnClickAccordion.bind(this, index)}
            >
              <div key={index} className="row no-gutters">
                <div className="col-12 row no-gutters values slim">
                  <div className="col-4">
                    <img
                      src={
                        this.props.brand?.icons?.cards?.small ?? evioSmallCard
                      }
                      alt="evio small card"
                    />
                    {contract.cardName}
                  </div>
                  <div className="col-2">{contract.networks[0].name}</div>
                  <div className="col-2">
                    <Translate value={contract.cardType} />
                  </div>
                  <div className="col-2">
                    <Translate
                      value={
                        contract.hasOwnProperty("fleetId")
                          ? "contracts_network_fleet"
                          : "contracts_network_company"
                      }
                    />
                  </div>
                  <div className="col-2">
                    <img
                      src={arrow}
                      alt=""
                      className={
                        this.state.collapsed[index] ? "arrow open" : "arrow"
                      }
                    />
                  </div>
                </div>
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <div className="network">
                  {this.renderNetworks(contract, this.state.masterContract)}
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      );
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <div className="top-nav-bar">
          <div>
            <button
              type="button"
              className="clear back"
              onClick={() => this.props.setContent("profile")}
            >
              <img src={back} alt="back" />
            </button>
          </div>
          <div></div>
        </div>
        <div id="contracts" className="main-component main-container">
          <div className="component-container">
            <div className="table-container">
              <div className="table-header">
                <div className="row no-gutters">
                  <div className="col-12 row no-gutters titles">
                    <div className="col-4 title">
                      <Translate value="contracts_network_card" />
                    </div>
                    <div className="col-2 title">
                      <Translate value="contracts_network_networks" />
                    </div>
                    <div className="col-2 title">
                      <Translate value="contracts_network_status" />
                    </div>
                    <div className="col-2 title">
                      <Translate value="contracts_network_type" />
                    </div>
                    <div className="col-2 title" />
                  </div>
                </div>
              </div>

              {this.state.userContractsReturned ? (
                this.renderContracts()
              ) : (
                <div className="loading-container">
                  <div className="loading-spinner">
                    <div className="generic-loading">
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <RequestNetworkAccess
          show={this.state.modals.requestNetworkAccess}
          onHide={() => this.setModal("requestNetworkAccess", false)}
          selectedContract={this.state.selectedContract}
          fetchFleets={this.fetchContracts.bind(this)}
        />
        <ActivateCard
          show={this.state.modals.activateCard}
          onHide={() => this.setModal("activateCard", false)}
          selectedContract={this.state.selectedContract}
          fetchFleets={this.fetchContracts.bind(this)}
        />
        <RequestPhysicalCard
          show={this.state.modals.requestPhysicalCard}
          onHide={() => this.setModal("requestPhysicalCard", false)}
          selectedContract={this.state.selectedContract}
          fetchFleets={this.fetchContracts.bind(this)}
        />
        <RequestPhysicalCard
          show={this.state.modals.associatePhysicalCard}
          onHide={() => {
            this.safeSetState(
              { associatedEdit: false, selectedContract: null },
              () => this.setModal("associatePhysicalCard", false)
            );
          }}
          associate={true}
          associatedEdit={this.state.associatedEdit}
          selectedContract={this.state.selectedContract}
          fetchFleets={this.fetchContracts.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  isCompany: state.account.isCompany,
  wasAdmin: state.account.wasAdmin,
  userPackage: state.account.accountData.userPackage,
});

export default connect(mapStateToProps, {
  setAlert,
})(Contracts);
